import React, { useRef } from 'react';
import axios from 'axios';
import storage from '../utils/storage';
import { Button } from 'primereact/button';
import { setLoading } from '../utils/uiActions';
import { useDispatch } from 'react-redux';

const DownloadFile = ({ filePath, directory = false, tooltipText = "Download File", toast, btnLabel = "" }) => {
    
    const dispatch = useDispatch(); // Get dispatch function
    
    const downloadIconRef = useRef(null);

    // Handle download click
    const handleDownloadClick = (filePath, directory) => {
        
        const updatedFilePath = filePath?.replace(/\\/g, '/');

        // Call getFileData function
        getFileData(updatedFilePath, directory, (message) => {
            // Show message using Toast
            if (message === 'file downloaded successfully') {
                toast?.current?.show({ severity: 'success', summary: 'Success', detail: message });
            } else {
                toast?.current?.show({ severity: 'error', summary: 'Error', detail: 'File download failed' });
            }
        });
    };

    const getFileData = (filePath, directory, callBackFunc) => {

        const URL = window && window.config && window.config.END_POINT;
        const token = storage.getToken();

        let API_URL =  directory ? `${URL}/integration/download?filePath=${filePath}&directory=${directory}` : `${URL}/integration/download?filePath=${filePath}`;

        let config = {
            method: 'get',
            url: API_URL,
            headers: { 'Authorization': token },
            responseType: 'blob'
        };

        dispatch(setLoading(true)); // Dispatch action

        axios.request(config).then((response) => {
                if (response.status === 200) {
                    const contentDisposition = response.headers['content-disposition'];
                    const isFileDownload = contentDisposition && contentDisposition.includes('attachment');
                    
                    if (isFileDownload) {
                        const filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        callBackFunc('file downloaded successfully');
                    } else {
                        callBackFunc('Failed to download file');
                    }
                } else {
                    callBackFunc('Failed to download file');
                }
                dispatch(setLoading(false)); // Dispatch action to stop loading
            })
            .catch((error) => {
                console.error("Error during file request:", error);
                callBackFunc('Failed to download file');
                 dispatch(setLoading(false)); // Stop loading even on failure
            });
    };

    return (
        <>
            {!btnLabel && 
                <i
                    ref={downloadIconRef}
                    className="pi pi-download download-icon floatRight tp"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDownloadClick(filePath, directory);
                    }}
                    data-pr-tooltip={tooltipText}
                />
            }

            {btnLabel && 

                <Button 
                    label={btnLabel} 
                    outlined 
                    icon="pi pi-download"
                    className='tp' 
                    iconPos="right" 
                    ref={downloadIconRef}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDownloadClick(filePath, directory);
                    }}
                    data-pr-tooltip={tooltipText}
                />
            }
        </>
    );
};

export default DownloadFile;
